import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";

const PremiumReceivablesIcon: OverridableComponent<
  SvgIconTypeMap<{}, "svg">
> & { muiName: string } = (props: SvgIconProps) => {
  const { width = 72, height = 72, color = "#9E233A", ...otherProps } = props;

  return (
    <SvgIcon
      {...otherProps}
      viewBox="0 0 72 72"
      sx={{ width, height }}
    >
      <g id="premium-receivables">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.047 3C40.577 3 41.086 3.211 41.461 3.586L59.414 21.539C59.789 21.914 60 22.423 60 22.953V38.5C58.5 37.8 56.9 37.5 55.2 37.2V25.313H37.688V8.667H15.667C15.115 8.667 14.667 9.115 14.667 9.667V60.083C14.667 60.635 15.115 61.083 15.667 61.083H36.5C37.3 63.1 38.5 65 40 66.75H15.375C13.684 66.75 12.063 66.078 10.867 64.883C9.672 63.687 9 62.066 9 60.375V9.375C9 7.684 9.672 6.063 10.867 4.867C12.063 3.672 13.684 3 15.375 3H40.047ZM21.75 46.917H34C33.3 48.5 32.8 50.2 32.5 52.583H21.75V46.917ZM21.75 35.583H47.25V41.25H21.75V35.583Z"
          fill={color}
        />
        <circle cx="55" cy="55" r="14" fill="none" stroke={color} strokeWidth="2.5"/>
        <text
          x="55"
          y="61"
          textAnchor="middle"
          fontSize="20"
          fontWeight="bold"
          fontFamily="Arial, sans-serif"
          fill={color}
        >
          $
        </text>
      </g>
    </SvgIcon>
  );
};

PremiumReceivablesIcon.muiName = "SvgIcon";

export default PremiumReceivablesIcon;
